export default {"src":"/_next/static/media/requirements.b6237e5e.svg","height":100,"width":150};